import $ from 'n-zepto'
import useSDK from '../data/useSDK'



const useAPI = () => {
    const { getAppid, getToken, getVer, getPF, getApiDomain, getFP, getClickId, getEncode, getDecode, getEncodex, getR } = useSDK();
    const request = async (url, params, { } = {}) => {
        //先从SDK获取请求api的域名，如果获取不到就从打包定义的获取;从sdk获取的目的是，不用每次掉备都要从新打包wap
        //但是有些旧的sdk没有提供getApiDomain方法，只能打包时提供
        let api_domain = getApiDomain();
        if (!api_domain) {
            api_domain = process.env?.REACT_APP_DOMAIN;
        }
        let app_id = getAppid();
        let token = getToken();
        let app_ver = getVer();
        let pf = getPF();
        let t = new Date().getTime();
        let r = 'w' + getR();
        let s = await getEncodex(r + t);
        const req_data = await getEncode(JSON.stringify({ token, app_ver, pf, app_id, ...params, r }));
        if (url?.startsWith("http") === false) url = api_domain + url;
        url = `${url}?r=${r}&t=${t}&s=${s}`;
        return await new Promise((resolve, reject) => {
            $.ajax(
                {
                    url,
                    data: { data: req_data },
                    type: "post",
                    dataType: 'json',
                    // headers: { fp, ckid, pf },
                    success: async (rs) => {
                        console.log('rs', rs)
                        if (rs?.data) {
                            const decode_data = await getDecode(rs.data);
                            rs.data = JSON.parse(decode_data);
                        }
                        resolve(rs);
                    }, error: rs => {
                        reject(rs);
                    }
                }
            )
        });
    }
    return { request }
}

export default useAPI;



// import $ from 'n-zepto'
// import useSDK from '../data/useSDK'





// const useAPI = () => {


//     const { getToken, getVer, getPF, getApiDomain, getFP, getClickId, getAppid } = useSDK()


//     // const setToken = (token) => {
//     //     window.localStorage.setItem("_token", token)
//     // }
//     // const getToken = () => {
//     //     return window.localStorage.getItem("_token")

//     // }


//     const request = async (url, params, { } = {}) => {
//         //先从SDK获取请求api的域名，如果获取不到就从打包定义的获取;从sdk获取的目的是，不用每次掉备都要从新打包wap
//         //但是有些旧的sdk没有提供getApiDomain方法，只能打包时提供
//         let api_domain = getApiDomain();
//         if (!api_domain) {
//             api_domain = process.env?.REACT_APP_DOMAIN;
//         }
//         let fp = getFP();
//         let ckid = getClickId();
//         let pf = getPF();
//         let app_id = getAppid();
//         // if (url?.startsWith("http") === false) url = process.env?.REACT_APP_DOMAIN + url;
//         if (url?.startsWith("http") === false) url = api_domain + url;
//         // console.log('getToken()',getToken())
//         return await new Promise((resolve, reject) => {
//             $.ajax(
//                 {
//                     url, data: { app_id, token: getToken(), app_ver: getVer(), pf, ...params },
//                     type: "get",
//                     dataType: 'json',
//                     headers: { fp, ckid, pf },
//                     success: (rs) => {
//                         resolve(rs)
//                     }, error: rs => {
//                         reject(rs)
//                     }
//                 }
//             )
//         });




//     }

//     return { request }

// }

// export default useAPI;